export default [
  {
    path: '/comercial',
    name: 'Comercial',
    component: () => import('@/pages/comercial/Comercial'),
    children: [
      /* Financiamento */
      {
        path: 'financiamento',
        name: 'Comercial.financiamento',
        meta: {
          descricao: 'Financiamento'
        },
        component: () => import('@/pages/comercial/financiamento/Finenciamento')
      },

      /* Consorcio */
      {
        path: 'consorcio',
        name: 'Comercial.consorcio',
        meta: {
          descricao: 'Consorcio'
        },
        component: () => import('@/pages/comercial/consorcio/Concorcio')
      },

      /* Adimplência */
      {
        path: 'adimplencia',
        name: 'Comercial.adimplencia',
        meta: {
          descricao: 'Adimplência'
        },
        component: () => import('@/pages/comercial/adimplencia/Adimplencia')
      },

      /* Inadimplência */
      {
        path: 'inadimplencia',
        name: 'Comercial.inadimplencia',
        meta: {
          descricao: 'Inadimplência'
        },
        component: () => import('@/pages/comercial/inadimplencia/Inadimplencia')
      },

      /* Retenção */
      {
        path: 'retencao',
        name: 'Comercial.retencao',
        meta: {
          descricao: 'Retenção'
        },
        component: () => import('@/pages/comercial/retencao/Retencao')
      }
    ]
  }
]
